import React from 'react';
import { Outlet } from 'react-router-dom';

export class MainLayout extends React.Component {
  render() {
    return (
      <div class="m-0 p-0" >
        <Outlet/>
      </div>
    );
  };    
}
